import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromNotifications from '../../reducers/notifications/notifications.reducer';

export const selectNotificationsState = createFeatureSelector<fromNotifications.State>(
  fromNotifications.notificationsFeatureKey
);

export const selectAllNotifications = createSelector(
  selectNotificationsState,
  (state) => state.notifications
);

export const selectUserNotifications = createSelector(
  selectNotificationsState,
  (state) => state.userNotifications
);

export const selectNotificationsLoading = createSelector(
  selectNotificationsState,
  (state) => state.loading
);

export const selectNotificationsSaving = createSelector(
  selectNotificationsState,
  (state) => state.saving
);

export const selectShowInactive = createSelector(
  selectNotificationsState,
  (state) => state.showInactive
);

export const selectFilteredNotifications = createSelector(
  selectAllNotifications,
  selectShowInactive,
  (notifications, showInactive) =>
    showInactive ? notifications : notifications.filter((n) => n.isActive)
);

export const selectUnreadCount = createSelector(
  selectUserNotifications,
  (notifications) => notifications.filter((n) => !n.isRead).length
);

export const selectWelcomeModalShown = createSelector(
  selectNotificationsState,
  (state) => state.welcomeModalShown
);
